import { Box, styled } from '@mui/material';

// Lienzo de la app: MISMO gris que el contenido, para que el sidebar flotante
// se apoye ENCIMA del gris (parte de la app) y no quede una franja negra
// (el fondo del body) dividiendo la pantalla a la izquierda del panel.
const StyledDefaultLayoutContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.gray2.main,
  display: 'flex',
  minHeight: '100vh'
}));

export default StyledDefaultLayoutContainer;
